import { Doughnut } from "react-chartjs-2"
import ChartDataLabels from "chartjs-plugin-datalabels"
import React from "react"
import { Grid2, Paper, Typography } from "@mui/material"
import { getGraphStyles } from "routes/sfg20-admin/plugins/system-info/activity-tab/graphs/graph-styles"

export function AnalysisDonut({ data, title, options = { fullwidth: false } }) {
    const { size, graphPaperSx, graphGridSx } = getGraphStyles(options)
    return (
        <Grid2 size={size} sx={graphGridSx}>
            <Paper elevation={3} sx={graphPaperSx}>
                <Doughnut
                    data={data}
                    plugins={[ChartDataLabels]}
                    options={{
                        plugins: {
                            legend: {
                                position: "right",
                                labels: {
                                    generateLabels: (chart) => {
                                        const { data } = chart
                                        if (data.labels.length && data.datasets.length) {
                                            return data.labels.map((label, i) => {
                                                const dataset = data.datasets[0]
                                                const value = dataset.data[i]
                                                const percentage = (
                                                    (value / dataset.data.reduce((a, b) => a + b, 0)) *
                                                    100
                                                ).toFixed(1)
                                                return {
                                                    text: `${label}: ${value} (${percentage}%)`,
                                                    fillStyle: dataset.backgroundColor[i],
                                                    hidden: !chart.getDataVisibility(i),
                                                    index: i,
                                                }
                                            })
                                        }
                                        return []
                                    },
                                },
                            },
                            datalabels: {
                                display: false, // Hide labels from inside the segments
                            },
                        },
                        offset: 60,
                    }}
                />
                <Typography mt={2} variant="subtitle1" sx={{ width: "100%", textAlign: "center", marginBottom: 2 }}>
                    {title}
                </Typography>
            </Paper>
        </Grid2>
    )
}
